
import { Injectable }             from '@angular/core';
import { Observable }             from 'rxjs/Observable';
import { Router, Resolve, RouterStateSnapshot,
         ActivatedRouteSnapshot } from '@angular/router';

import { ProductsService } from './products/products.service';
import { Product, Category, CategoryResponse, CategoryItems} from './products/product';

import { ControlsService } from './controls.service';
import { map, switchMap, tap, take } from 'rxjs/operators';
import { empty } from 'rxjs/observable/empty';
import { from } from 'rxjs/observable/from';


import { zip } from 'rxjs/observable/zip';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { Query } from './products/query';



@Injectable()
export class CategoriesResolverService implements Resolve<any> {
  constructor(
    private ps: ProductsService, 
    private router: Router,
    private cs: ControlsService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CategoryItems[]> {
    let id:number = +route.paramMap.get('id');
    let idSet: any = route.paramMap.has('id');

    const filter: Query = { page: 1, category: id };

    return this.ps.getCatoriesChildren(id);

    // return this.ps.getCategorySubItems(filter, idSet)
    // .pipe(
    //     map((items: CategoryItems[]) => {
    //           if (items.length) {
    //             return items;
    //           } else { // id not found
    //             this.router.navigate(['/products',{id:id}]);
    //             return null;
    //           }
    //         })
    // )


    // return <any>combineLatest(
    //   this.cs.getFreeControlSubject().pipe(map(freeMod => (freeMod)? 'free': '')),
    //   this.cs.getRecentControlSubject().pipe(map(recentMod => (recentMod)? 5: 10)),
    //   (freeControl: string, recentControl: number) => {
    
    //     return {type: freeControl, category: id || null, page: 1, limit: recentControl } 
    //   }
    // ).pipe(
    //     take(1),
    //     switchMap((filter: Query )=> this.ps.getCategorySubItems(filter, idSet)),
    //     map((items: CategoryItems[]) => {
    //           if (items.length) {
    //             return items;
    //           } else { // id not found
    //             this.router.navigate(['/products',{id:id}]);
    //             return null;
    //           }
    //         })
  
    //   );


    // return this.cs.getFreeControlSubject()
    // .pipe(
    //   take(1),
    //   map(freeMod => (freeMod)? 'free': ''),
    //   switchMap(freeControl => this.ps.getCategorySubItems({category: id, type: freeControl}, idSet)),
    //   map((items: CategoryItems[]) => {
    //     if (items.length) {
    //       return items;
    //     } else { // id not found
    //       this.router.navigate(['/products',{id:id}]);
    //       return null;
    //     }
    //   })
    // );
    


  }
}



// WEBPACK FOOTER //
// ./src/app/categories-resolver.service.ts